import { ArrowRightLeft, Building2 } from "lucide-react";
import { OrganizacaoEmFoco } from "@/components/organization/painel/OrganizacaoEmFoco";
import { useAbrirNaOrganizacao } from "@/lib/use-abrir-na-organizacao";
import { ProsthesisOrderDetailDialog } from "./ProsthesisOrderDetailDialog";
import { useDeOutraOrganizacao } from "./PacienteDoPedido";
import type { ProsthesisOrderRow } from "./types";

/**
 * O detalhe do pedido aberto na lista. Pedido de outra organização (acesso pessoal) abre com ela
 * em foco e só leitura — sem trocar a ativa —, com "Abrir em" pra quem quiser agir nele.
 */
export function DetalheDoPedidoDaLista({
  order,
  onClose,
  onEditar,
}: {
  order: ProsthesisOrderRow | null;
  onClose: () => void;
  onEditar?: (order: ProsthesisOrderRow) => void;
}) {
  const deOutra = useDeOutraOrganizacao();
  const { abrir, abrindo } = useAbrirNaOrganizacao();
  const org = order?.organization;

  if (!order || !org || !deOutra(order)) {
    return <ProsthesisOrderDetailDialog orderId={order?.id ?? null} onClose={onClose} onEditar={onEditar} />;
  }

  const nome = org.isPersonal ? "Pessoal" : org.name;
  const aviso = (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-brand-100 bg-brand-50 px-3 py-2 text-[13px] text-brand-800 dark:border-primary/20 dark:bg-primary/10 dark:text-primary">
      <Building2 className="h-4 w-4 shrink-0" />
      <span className="min-w-0 flex-1">
        Pedido de <strong>{nome}</strong> — aqui só leitura.
      </span>
      <button
        type="button"
        disabled={abrindo}
        onClick={() => abrir(org.id, nome, `/protese?abrir=${order.id}`)}
        className="inline-flex h-8 shrink-0 items-center gap-1.5 rounded-md bg-brand-600 px-3 text-xs font-semibold text-white hover:bg-brand-700 disabled:opacity-50"
      >
        <ArrowRightLeft className="h-3.5 w-3.5" />
        Abrir em {nome}
      </button>
    </div>
  );

  return (
    <OrganizacaoEmFoco key={org.id} organizationId={org.id} somenteLeitura>
      <ProsthesisOrderDetailDialog orderId={order.id} onClose={onClose} readOnly aviso={aviso} />
    </OrganizacaoEmFoco>
  );
}
